export class Reservas {
    ReservaId?: number;
    Smeid?: number;
    Finicio?: Date;
    Ffin?: Date;
    Caption: string;
    TipoEvento?: number;
    Opciones?: number;
}
